module.exports = __webpack_public_path__ + "static/cload-ade7b812d2567f67b26d65fad798c49d.svg";